import { useEffect, useState } from "react"
import { useStyles } from "../../../style/styles"
import { IProps } from "./types"
import { splitUserArn } from "../../../lib/messageUtils"
import { Grid, Typography, Avatar } from "@mui/material"
import React from "react"
import parse from 'html-react-parser'
import { stringToAvatar, getTimeStringDate } from "../../../lib"


const ChatMessage = (props: IProps) => {

    const classes = useStyles()
    const {
      channel,
      user,
        // channelArn,
        //   userArn,
          prevMessage,
          message,
          isLastMessage,
          channelMetadata
    } = props

    const { channelArn } = channel
    const dateTime = new Date(message.CreatedTimestamp)
    const isSelf = splitUserArn(message.Sender.Arn) === user?.userArn
    const sender = message.Sender.Name
    const [timeElapsed, setTimeElapsed] = useState<string>('')
    const [isNotSameFromPrev, setIsNotSameFromPrev] = useState<boolean>(prevMessage !== null && prevMessage?.Sender?.Arn !== message.Sender.Arn)
    const [isPrevEndedOrReenabled, setIsPrevEndedOrReenabled] = useState<boolean>(false)

    // Update isNotSameFromPrev when prevMessage changes
    useEffect(() => {
      if (prevMessage) {
        setIsNotSameFromPrev(prevMessage.Sender.Arn !== message.Sender.Arn);
        setIsPrevEndedOrReenabled(false);
      } else {
        // If there's no previous message, always show the avatar (new channel case)
        setIsNotSameFromPrev(true);
      }
    }, [message, prevMessage]);

    // Time elapsed update logic
    useEffect(() => {
      const interval = setInterval(() => {
        updateTimeElapsed()
      }, 1000)
      updateTimeElapsed()
      return () => clearInterval(interval);
    }, [message])

    const updateTimeElapsed = () => {
      const currentTime = new Date().getTime()
      const elapsedTime = Math.floor((currentTime - dateTime.getTime()) / 1000)
      setTimeElapsed(getTimeStringDate(dateTime))
    }

    /*
        Old/Original function --> format \n from messageContent to <br>
        Additional --> TJSKR-2780: Convert detected raw <a> tag from messageContent to full clickable <a href> tag
        TODO: Transfer to utils (?)
    */
    const formatMessage = (text: string): { lines: string[], brCount: number } => {
        const enhanceLinkTag = (input: string): string => {
        const aTagRegex = /<a>(.*?)<\/a>/gi
        return input.replace(aTagRegex, (match, linkText) => {
            const cleanText = linkText.trim()
            const href = message?.Metadata ? JSON.parse(message?.Metadata)?.link : "" /* Replace with interviewerLink value from CM */
            return `<a href="${href}" target="_blank" rel="noopener noreferrer">${cleanText}</a>`
        })
        }

        const enhancedText = enhanceLinkTag(text)
        const lines = enhancedText.split('\n').map((line, index) => {
        // Trim leading whitespace
        return index === 0 ? line : line.trimStart()
        })
        const brCount = lines.length - 1
        return { lines, brCount }
    }

    const { lines, brCount } = formatMessage(message?.Content)

    const formatChatName = (text: string) => {
      return (!text.includes('@') && !text.includes(' ')) ? text : text.split(/[@ ]/).filter(Boolean)
    }

    return (
      // TODO: ADD REDACTED status checking and handling
      <div className={classes.messageBodyContainer}>
        {/* TODO: Add checking for ended convo */}
        { isSelf ? (
          <>
            <div className={classes.timeMessageContainer}>
              <Grid container direction='column'>
                <Grid item container justifyContent='right' alignContent='right' sx={{ width: '100%', marginBottom: '8px' }}>
                  <Typography sx={{ color: '#888', fontSize: '12px' }}>
                    { isNotSameFromPrev || isPrevEndedOrReenabled ? 'You, ' + timeElapsed : timeElapsed }
                  </Typography>
                </Grid>
                <Grid item container justifyContent='right' alignContent='right' sx={{ width: '100%' }}>
                  <div className={props.platform === 'mobile' ? classes.messageContentSelf : classes.messageContentOther}>
                    {/* TODO: handle styling for mobile */}
                    <Typography className={props.platform === 'mobile' ? classes.messageTextSelf : classes.messageTextOther} sx={{ fontSize: '14px', wordWrap: 'break-word', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                      { lines?.map((line, index) => (
                          <React.Fragment key={index}>
                            { parse(line) }
                            {index<brCount && <br/>} {/* Render <br> for each '\n' in the original text */}
                          </React.Fragment>
                        ))}
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </div>
            <div style={{ marginLeft: '10px' }}>
              <div className={classes.avatar}>
                { isNotSameFromPrev || isPrevEndedOrReenabled ? (
                  <Avatar {...stringToAvatar(sender)} />
                ) : (<></>)}
              </div>
            </div>
          </>
          ) : (
            <>
              <div className={classes.avatar}>
                { isNotSameFromPrev || isPrevEndedOrReenabled ? (
                    <Avatar {...stringToAvatar(sender)} />
                  ) : (<></>)}
              </div>
              <div className={classes.timeMessageContainer}>
                <Grid container direction='column' sx={{ marginLeft: '10px' }}>
                  <Grid item container justifyContent='left' alignContent='left' sx={{ width: '100%', marginBottom: '8px' }}>
                    <Typography sx={{ color: '#888', fontSize: '12px' }}>
                      { isNotSameFromPrev || isPrevEndedOrReenabled ? formatChatName(sender)[0] + ', ' + timeElapsed : timeElapsed }
                    </Typography>
                  </Grid>
                  <Grid item container justifyContent='left' alignContent='left' sx={{ width: '100%' }}>
                    <div className={classes.messageContentOther}>
                      <Typography className={classes.messageTextOther} sx={{ fontSize: '14px', wordWrap: 'break-word', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                        { lines?.map((line, index) => (
                            <React.Fragment key={index}>
                              { parse(line) }
                              {index<brCount && <br/>} {/* Render <br> for each '\n' in the original text */}
                            </React.Fragment>
                          ))}
                      </Typography>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </>
          )
        }
      </div>
    )
}

export default ChatMessage
